import {
    Center,
    ChakraProvider,
    ColorModeScript,
    Flex,
    Grid,
    GridItem,
    HStack,
    Link,
    Stack,
    useToast,
} from '@chakra-ui/react'
import React, {useEffect, useState} from 'react';
import {
    Box,
    Button,
    Card,
    CardBody, CardFooter,
    Divider,
    Editable, EditableInput,
    EditablePreview,
    Heading, Input,
    InputGroup,
    Text,
    Textarea, VStack,
} from "@chakra-ui/react";
import {keyframes} from "@emotion/react";
import PictureContainer from "../components/PictureContainer";

import {ArrowDownIcon} from "@chakra-ui/icons";
import { useSpring, animated } from 'react-spring';
import CoverImages from "../components/CoverImages";
import cover1 from "../gallery/cover_1.jpg"
import cover4 from "../gallery/cover4_2.jpg"
import cover3 from "../gallery/cover_3.jpg"
function Coverpage(){

    const AnimatedElement = ({ delay, children }) => {
        const [isVisible, setIsVisible] = useState(false);
        const props = useSpring({
            opacity: isVisible ? 1 : 0,
            transform: isVisible ? 'translateY(0vh)' : 'translateY(-2vh)',
            config: { duration: 500 },
            delay
        });

        useEffect(() => {
            setIsVisible(true);
        }, []);

        return <animated.div style={props}>{children}</animated.div>;
    };

    const title_style_1 = { base: "17px", sm:"20px", md: "28px", lg: "35px", "2xl":"35px"};
    const title_style_2 = { base: "12px", sm: "15px", md: "16px", lg: "16px", xl: "20px","2xl":"20px"};
    const alignStyle = {base:"start",md:"start"};


    const cover_text_1 ="Door and window furniture and hardware..."
    const cover_text_1_2 = "Fire door and fire door hardware installation.\n"
    const cover_text_1_3 = "Shelving and window sills……..\n"
    const cover_text_2 = "We craft masterpieces through custom designs and flawless finishes";
    const cover_text_2_2 = "Have more than 17 years of working experience in carpentry";
    const cover_text_3 = "We are";
    const first_part =[cover_text_1,cover_text_1_2,cover_text_1_3,cover_text_2,cover_text_2_2,cover_text_3];

    const time_gap = 600;

    const backgroundImageArr = [
        {img:cover4,bp: "0% 35%",title:"MJ carpentry and joinery",
            description:"Have more than 20 years of working experience as experts in providing high Qualified and Licensed Carpentry Services."},
        {img:cover1,bp: "0% 45%",title:"Door and window furniture and hardware...",
            description:"Fire door and fire door hardware installation, shelving and window sills... "},
        {img:cover3,bp: "0% 25%",title:"Let us build your vision, one nail at a time",
            description:"We craft masterpieces through custom designs and flawless finishes"},
    ] ;
    const [index, set_index] = useState(0);

    const img_height = {base:"35vh",md:"80vh"}
    const margin_top = {base:"10vh",md:"14vh"}

    const page_height = {base:"25vh",md:"65vh"}
    const page_margin_bottom = {base:"0vh",md:"0vh"}

    const cover_button_size = {base:"xs",md:"md",xl:"lg"}
    const cover_button_fontsize = {base:"10px",md:"16px",xl:"22px"}


    function changeimg(){
        if (index===backgroundImageArr.length-1){
            set_index(0)
        }else{
            set_index(index+1)
        }
    }

    useEffect(() => {

        const interval = setInterval(() => {
            set_index(prevValue=>(prevValue + 1) % backgroundImageArr.length)
        }, 5000);

        return () => clearInterval(interval);
    }, []);


     // setInterval(() => {
     //        changeimg()
     //        console.log(index)
     //    }, 5000);

    // clearInterval(interval)
    // useEffect(() => {
    //     const interval = setInterval(() => {
    //         changeimg()
    //         console.log(index)
    //     }, 1000);
    //     return () => clearInterval(interval);
    //
    // }, []);


    return (

    <>

            <Box marginTop ={{base:"33%",md:"23%",xl:"15%","2xl":"11%"}} h = {img_height} w = {{base: "100vw" , md:"98vw"}}  transition={"1s"}
                 align = "start"
                 style = {{

                     "background-position": backgroundImageArr[index].bp,
                     "background-size": "cover",
                     "background-repeat": "no-repeat",

                     }} display={"flex"} justifyContent={{base: "center" , md:"center"} } alignItems={{base: "center" , md:"center"}} background={`url(${backgroundImageArr[index].img})`}>

                <VStack w ={{base:"95vw",xl:"35%"}} h ={{base:"70%",xl:"50%"}}  display={"flex"} justifyContent={"center"} alignItems={"center"}  >
                    <VStack alignItems={"center"} padding={"3%"}>

                        <Text style={{
                            textAlign: "center",
                            WebkitTextStroke: "0.5px whiteghost",
                        }} color = "white" as = "b" fontSize = {title_style_1}>{backgroundImageArr[index].title}</Text>
                        <Text color = "white" as = "b" fontSize = {title_style_1}  style={{
                            textAlign: "center",
                            WebkitTextStroke: "0.5px whiteghost",
                        }}>{backgroundImageArr[index].description}</Text>

                        <HStack mt={"10px"}>
                            <Button boxShadow={"1px 1px 1px 1px black"} borderRadius = "0" color = "white"  size = {cover_button_size} bg = "blackAlpha.500"  _hover = {{background:"#AD3F45",border:"none"}}  transition="1s">
                                <Text margin = "10px" fontFamily="Calibri" fontSize={cover_button_fontsize} onClick = {()=>{
                                    document.getElementById("contact").scrollIntoView({ behavior: 'smooth',block: 'end'});
                                }}>Free Estimate & Quote</Text>
                            </Button>
                            {/*<Button boxShadow={"1px 1px 1px 1px black"} ml = "10%" borderRadius = "0" color = "white"  size = {cover_button_size}   bg = "blackAlpha.500"  _hover = {{background:"#AD3F45",border:"none"}}  transition="1s">*/}
                            {/*    <Text margin = "10px" fontFamily="Calibri" fontSize={cover_button_fontsize} onClick = {()=>{*/}
                            {/*    document.getElementById("gallery").scrollIntoView({ behavior: 'smooth',block: 'center'});*/}
                            {/*    }} >Visit gallery</Text>*/}
                            {/*</Button>*/}
                        </HStack>

                    </VStack>

                </VStack>

            </Box>


    </>
    )
}

export default Coverpage;